import { AppConfig, IAppConfigTranslate } from '@shared/utils/app-config';
import { LOCATION_INITIALIZED } from '@angular/common';
import { Injectable, Injector } from '@angular/core';
import { TranslateLoader, TranslateService } from '@ngx-translate/core';
import { catchError, map, Observable } from 'rxjs';
import { BaseApiService } from '@shared/data-access';

export function translateConfiguration(translateService: TranslateService, injector: Injector, appConfig: AppConfig): () => Promise<boolean> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  return () =>
    new Promise<boolean>((resolve) => {
      const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      locationInitialized.then(() => {
        const defaultLang = Object.keys(appConfig.translations)[0];
        translateService.setDefaultLang(defaultLang);
        translateService.use(defaultLang).subscribe(
          () => {},
          () => {},
          () => {
            resolve(true);
          }
        );
      });
    });
}

@Injectable({
  providedIn: 'root',
})
export class TranslationFromJsonService implements TranslateLoader {
  public constructor(private apiService: BaseApiService, private appConfig: AppConfig, private translateService: TranslateService) {}

  public getTranslation(lang: keyof IAppConfigTranslate): Observable<unknown> {
    const url = this.appConfig.translations[lang];

    return this.apiService.get(url).pipe(catchError(() => this.getTranslationFromAssets(lang)));
  }

  public getTranslationFromAssets(lang: keyof IAppConfigTranslate): Observable<unknown> {
    const url = this.appConfig.translations[lang];

    return this.apiService.get(url).pipe(map((response) => new Object(response)));
  }

  public instant(key: string): string {
    return this.translateService.instant(key);
  }
}
